import { AnimatePresence, motion } from "framer-motion";
import React from "react";
import AnimateHeight from "react-animate-height";
import { PulseLoader } from "react-spinners";
const MIN_HEIGHT = 100;
export default class AutoHeightLoader extends React.Component {
    render() {
        const { children, isLoading } = this.props;
        return (React.createElement("div", { style: {
                minHeight: MIN_HEIGHT,
                position: "relative"
            } },
            React.createElement(AnimatePresence, null, isLoading &&
                React.createElement(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, transition: { type: "spring" }, style: {
                        position: "absolute",
                        display: "table",
                        minHeight: MIN_HEIGHT,
                        left: "50%",
                        transform: "translateX(-50%)",
                    } },
                    React.createElement(Loader, null))),
            React.createElement(AnimateHeight, { duration: 1000, height: isLoading ? 0 : 'auto' }, children)));
    }
}
// interface LoaderProps {
//     isLoading: boolean
// }
class Loader extends React.Component {
    render() {
        const colour = "#000";
        //const {isLoading} = this.props
        return (React.createElement(PulseLoader, { color: colour, size: 25, loading: true, speedMultiplier: .8, cssOverride: {
                display: "table-cell",
                verticalAlign: "middle"
            } }));
    }
}
